import { prop } from "ramda";
import { createSelector } from "reselect";

const userReferenceSelector = (state: any) => state.userReference;
const formState = (state: any) => state.form;

export const selectFilterForm = createSelector(
  formState,
  prop("UserReferenceFormFilter")
);

export const selectUsers: any = createSelector(
  userReferenceSelector,
  prop("users")
);

export const selectUsersLoader: any = createSelector(
  userReferenceSelector,
  prop("usersLoader")
);

export const selectUserManagers: any = createSelector(
  userReferenceSelector,
  prop("userManagers")
);

export const selectUserOus: any = createSelector(
  userReferenceSelector,
  prop("userOus")
);

export const selectSelectedUser: any = createSelector(
  userReferenceSelector,
  prop("selectedUser")
);

export const selectUsersManaged: any = createSelector(
  userReferenceSelector,
  prop("usersManaged")
);

export const selectUsersManagedList: any = createSelector(
  selectUsersManaged,
  (el: any) => (el.list ? el.list : [])
);

export const selectUsersManagedLoader: any = createSelector(
  selectUsersManaged,
  (el: any) => (el.loader ? el.loader : false)
);

export const selectUserEntitlements: any = createSelector(
  userReferenceSelector,
  prop("userEntitlements")
);

export const selectEntitlementsOfBRSelected: any = createSelector(
  userReferenceSelector,
  prop("entitlementsOfBR")
);
